export const GARemoveFromCart = (p, phrases) => {
  const itemVariant = p.options.size ? { item_variant: `${phrases.size} - ${p.options.size}` } : {};
  const itemCategory2 = p.options.metal ? { item_category2: p.options.metal } : {}
  const itemCategory3 = p.options.metal_color ? { item_category3: p.options.metal_color } : {}
  const itemCategory4 = p.options.product_collection ? { item_category4: p.options.product_collection } : {}
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "remove_from_cart",
    ecommerce: {
      items: [
        {
          item_name: p.name,
          item_id: p.options.parent_product.sku,
          price: p.price,
          item_category: p.options.categories,
          item_brand: "Укрзолото",
          quantity: 1,
          ...itemVariant,
          ...itemCategory2,
          ...itemCategory3,
          ...itemCategory4,
        },
      ],
    },
  });
};
